export const RemoveUnwantedCharsRegex = /[-_$*+~.()'"!:@]+/g;
export const PascalCasingRegex = /([a-z0-9])([A-Z])/;
export const SplitRegex = /[\s]+/;
